export default __webpack_public_path__ + "static/media/cricInfo.b12c39bf.png";